<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-flex>
      <app-upsert
        v-if='protocol.id'
        :config="config"
        :item="hiddenFields"
        :title="protocol && protocol.name"
        @saved="saved" />

    </v-flex>

  </v-container>
</template>

<script>

import config from './config_new.js'
import moment from 'moment'
const { getDetail } = require('@/api/base_entity')

export default {
  data () {
    return {
      config,
      hiddenFields: {},
      protocol: {}
    }
  },
  async created () {
    this.protocol = await getDetail('protocol', { id: this.$route.params.protocolId })
    this.hiddenFields = { protocol_id: this.protocol.id,
      request_date: moment().format('YYYY-MM-DD') }

  },
  methods: {
    saved ({ data }) {
      this.$router.push(`/request/${data.id}`)
    }
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}
</style>
